/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import ActionConstants from '../constants';
import {
  getMerchantListApi,
  getMerchantMigrationDataApi,
  merchantSearchApi,
  migratedMerchantSearchApi,
  merchantOdsDataApi
} from '../../api/merchantListing';
import { getCancelableRequestMeta } from './cancelableRequest';

export const getMerchantListAction = (data) => {
  const { cancelKey, requestId, requestData, hideLoader, loaderMessage } =
    getCancelableRequestMeta(data, ActionConstants.GET_MERCHANT_LIST, true);
  const payload = {
    serviceMethod: getMerchantListApi.bind(null, requestData),
    actionTypeSuccess: ActionConstants.GET_MERCHANT_LIST_SUCCESS,
    actionTypeFailure: ActionConstants.GET_MERCHANT_LIST_FAILURE,
    actionTypeRequest: ActionConstants.GET_MERCHANT_LIST_REQUEST,
    hideLoader,
    loaderMessage,
    cancelKey,
    extra: { requestId, queryKey: data?.queryKey },
  };
  return { type: ActionConstants.GET_MERCHANT_LIST, payload };
};

export const getMerchantMigrationDataAction = (data) => {
  const { cancelKey, requestId, requestData, hideLoader, loaderMessage } =
    getCancelableRequestMeta(
      data,
      ActionConstants.GET_MERCHANT_MIGRATION_DATA,
      true
    );
  const payload = {
    serviceMethod: getMerchantMigrationDataApi.bind(null, requestData),
    actionTypeSuccess: ActionConstants.GET_MERCHANT_MIGRATION_DATA_SUCCESS,
    actionTypeFailure: ActionConstants.GET_MERCHANT_MIGRATION_DATA_FAILURE,
    actionTypeRequest: ActionConstants.GET_MERCHANT_MIGRATION_DATA_REQUEST,
    hideLoader,
    loaderMessage,
    cancelKey,
    extra: { requestId, queryKey: data?.queryKey },
  };
  return { type: ActionConstants.GET_MERCHANT_MIGRATION_DATA, payload };
};

export const migratedMerchantSearchAction = (data) => {
  const { cancelKey, requestId, requestData } = getCancelableRequestMeta(
    data,
    ActionConstants.MIGRATED_MERCHANT_SEARCH,
    true
  );
  const payload = {
    serviceMethod: migratedMerchantSearchApi.bind(null, requestData),
    actionTypeSuccess: ActionConstants.MIGRATED_MERCHANT_SEARCH_SUCCESS,
    actionTypeFailure: ActionConstants.MIGRATED_MERCHANT_SEARCH_FAILURE,
    actionTypeRequest: ActionConstants.MIGRATED_MERCHANT_SEARCH_REQUEST,
    hideLoader: true,
    cancelKey,
    extra: { requestId },
  };
  return { type: ActionConstants.MIGRATED_MERCHANT_SEARCH, payload };
};

export const merchantSearchAction = (data) => {
  const { cancelKey, requestId, requestData } = getCancelableRequestMeta(
    data,
    ActionConstants.MERCHANT_SEARCH,
    true
  );
  const payload = {
    serviceMethod: merchantSearchApi.bind(null, requestData),
    actionTypeSuccess: ActionConstants.MERCHANT_SEARCH_SUCCESS,
    actionTypeFailure: ActionConstants.MERCHANT_SEARCH_FAILURE,
    actionTypeRequest: ActionConstants.MERCHANT_SEARCH_REQUEST,
    hideLoader: true,
    cancelKey,
    extra: { requestId },
  };
  return { type: ActionConstants.MERCHANT_SEARCH, payload };
};

export const clearMerchantListAction = (screenResetId?: string) => {
  return {
    type: ActionConstants.GET_MERCHANT_LIST_CLEAR,
    payload: screenResetId ? { screenResetId } : undefined,
  };
};

export const clearMerchantSearchRecordsAction = (screenResetId?: string) => {
  return {
    type: ActionConstants.MERCHANT_SEARCH_CLEAR,
    payload: screenResetId ? { screenResetId } : undefined,
  };
};

export const clearMerchantMigrationDataAction = (screenResetId?: string) => {
  return {
    type: ActionConstants.GET_MERCHANT_MIGRATION_DATA_CLEAR,
    payload: screenResetId ? { screenResetId } : undefined,
  };
};

export const clearMerchantSearchAction = (screenResetId?: string) => {
  return {
    type: ActionConstants.MIGRATED_MERCHANT_SEARCH_CLEAR,
    payload: screenResetId ? { screenResetId } : undefined,
  };
};

export const getMerchantOdsDataAction = () =>{
  const payload ={
    serviceMethod: merchantOdsDataApi.bind(null),
    actionTypeSuccess: ActionConstants.MERCHANT_ODS_DATA_SUCCESS,
    actionTypeFailure: ActionConstants.MERCHANT_ODS_DATA_FAILURE,
    actionTypeRequest: ActionConstants.MERCHANT_ODS_DATA_REQUEST,
  };
  return { type:ActionConstants.MERCHANT_ODS_DATA, payload};
};
